import zhCN from './json/lottery.zh_CN.json';
import zhTW from './json/lottery.zh_TW.json';
import en from './json/lottery.en.json';
import ja from './json/lottery.ja.json';
import ko from './json/lottery.ko.json';
import ru from './json/lottery.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
